class PdpRelatedProducts {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.swiperEl = element.querySelector('.pdp-related-products__swiper');
    this.paginationEl = element.querySelector('.pdp-related-products__pagination');
    this.init();
  }

  init() {
    if (!this.swiperEl || !this.paginationEl) return;
    if (typeof window.Swiper === 'undefined') {
      requestAnimationFrame(() => this.init());
      return;
    }

    const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    this.swiper = new window.Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      pagination: {
        el: this.paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

function initPdpRelatedProducts() {
  document.querySelectorAll('.pdp-related-products').forEach((section) => {
    if (!section.pdpRelatedProducts) {
      section.pdpRelatedProducts = new PdpRelatedProducts(section);
    }
  });
}

function initSection(container) {
  const section = container.querySelector?.('.pdp-related-products') ?? container.closest?.('.pdp-related-products');
  if (!section) return;
  if (section.pdpRelatedProducts) section.pdpRelatedProducts.destroy();
  section.pdpRelatedProducts = new PdpRelatedProducts(section);
}

function destroySection(container) {
  const section = container.querySelector?.('.pdp-related-products') ?? container.closest?.('.pdp-related-products');
  if (section?.pdpRelatedProducts) {
    section.pdpRelatedProducts.destroy();
    section.pdpRelatedProducts = null;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpRelatedProducts);
} else {
  initPdpRelatedProducts();
}

document.addEventListener('shopify:section:load', (e) => initSection(e.target));
document.addEventListener('shopify:section:unload', (e) => destroySection(e.target));
